<div class="ngx-mat-tel-input-container" [class.single]="isSingleCountry">
    <button type="button" mat-button (mousedown)="showCountryDialog(focusable)" class="country-selector" [disabled]="disabled">
        <span class="country-selector-flag flag" [ngClass]="selectedCountry?.flagClass"></span>
		@if (selectedCountry?.dialCode) {
			<span class="country-selector-code">+{{ selectedCountry.dialCode }}</span>
		}
    </button>
    <input matInput
           type="tel"
           autocomplete="tel"
           [ngClass]="cssClass"
           (blur)="onTouched()"
           (keypress)="onInputKeyPress($event)"
           [(ngModel)]="phoneNumber"
           (ngModelChange)="onPhoneNumberChange()"
           [errorStateMatcher]="errorStateMatcher"
           [placeholder]="placeholder"
           [disabled]="disabled"
           [aria-describedby]="describedBy"
           #focusable />
</div>
